import { render, staticRenderFns } from "./PopUpSuccess.vue?vue&type=template&id=19c624b2"
import script from "./PopUpSuccess.vue?vue&type=script&lang=js"
export * from "./PopUpSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports